import React, { useEffect, useMemo, useState } from "react";
import Grid from "@material-ui/core/Grid";

import get from "lodash/get";
import { useDispatch, useSelector } from "react-redux";
// import { isMenuAllowed } from "components/HasPermission";
import { isSupplierOnly } from "utils";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import RefreshIcon from '@material-ui/icons/Refresh';
import { Box, Button } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import moment from "moment";
import { HasPermission, isActionAllowed, isMenuAllowed } from "components/HasPermission";
import CustomDatePicker from "components/CustomDatePicker";
import { updateDashboardDate } from "redux/filterReducer";
import LinearProgress from "@material-ui/core/LinearProgress";
import InvoicesTable from "../../components/InvoicesToValidate";
import MyTasks from "./components/MyTasks";
import PaidAndUnpaidInvoice from "./components/PaidAndUnpaidInvoice";
import AddInvoice from "./components/AddInvoice";
import { fetchSettingsByModuleName } from "../../redux/actions/users";
import useStyles from "./style";
import LitigeInvoicesRates from "./components/LitigeInvoicesRates";
import PerformanceAutomation from "./components/PerformanceAutomation";


const formatSettings = (data) =>
	data.reduce((acc, { code, value }) => ({ ...acc, [code]: parseInt(value, 10) }), {});

function Home() {
	const classes = useStyles();
	const { t } = useTranslation();
	const [dateRange, setDateRange] = useState({
			start: moment('2019-10-10').format("yyyy-MM-DD"),
			end: moment().format("yyyy-MM-DD")
		});
	const currentUser = useSelector(({ requests }) =>
		get(requests, "queries.FETCH_CURRENT_USER.data")
	);
	const currentUserPermissions = useMemo(() => get(currentUser, "permissions"), [currentUser]);
	const dispatch = useDispatch();
	const [settings, setSettings] = React.useState({});

	useEffect(() => {
		if (currentUser && !isSupplierOnly(get(currentUser, "roles", [])))
			dispatch(fetchSettingsByModuleName("invoice")).then((res) => {
				if (get(res, "data")) {
					setSettings(formatSettings(res.data));
				}
			});
	}, [dispatch, currentUser]);

	const getPermissionsValue = (menu, action) => {
		if (isActionAllowed(currentUserPermissions, menu, action)) {
			return 1;
		}
		return 0;
	};

	const applyDateFilter = () => {
        dispatch(updateDashboardDate({
            start: dateRange.start,
            end: dateRange.end
        }));
    };

	const indicatorsLoading = useSelector(({ requests }) =>
		get(requests, "queries.FETCH_COUNT_INVOICE_INDICATOR.pending", false)
	);
	const col1 = getPermissionsValue("Dashboard invoices", "My invoices") > 0;
	const col2 =
		getPermissionsValue("Dashboard invoices", "Exported invoices") +
			getPermissionsValue("Invoices list", "Add") >
		0;
	const col3 =
		getPermissionsValue("Dashboard invoices", "Last actions") +
			getPermissionsValue("Dashboard invoices", "Non exported invoices") >
		0;

	const col = 12 / (col1 + col2 + col3);

	return (
		get(currentUser, "roles") &&
		(currentUser.roles.includes("invoice_user") || currentUser.roles.includes("manager")) && (
			<>
				<Grid container xs={12} style={{justifyContent: 'end'}}>
				<Grid container item xs={8} spacing={1} alignItems="center" style={{justifyContent: 'end', marginBottom: '8px', marginTop: '10px'}}>

					<Grid item xs={5} sm={4} md={3}>
						<CustomDatePicker
							selectedDate={dateRange.start}
							onChange={value => setDateRange({ ...dateRange, start: value ? moment(value).format("yyyy-MM-DD") : null })}
							label={t('start')}
							minDate={moment('2019-10-10').format("yyyy-MM-DD")}
							maxDate={moment().format("yyyy-MM-DD")}
							required
						/>
					</Grid>

					<Grid item>
						<Box mx={1}><ArrowRightAltIcon /></Box>
					</Grid>

					<Grid item xs={5} sm={4} md={3}>
						<CustomDatePicker
							selectedDate={dateRange.end}
							onChange={value => setDateRange({ ...dateRange, end: value ? moment(value).format("yyyy-MM-DD") : null })}
							label={t('end')}
							minDate={dateRange.start}
							maxDate={moment().format("yyyy-MM-DD")}
							required
						/>
					</Grid>

					<Grid item>
						<Box mr={1} mt={0.5}>
						<Button variant="contained" size="large" disableElevation onClick={applyDateFilter}>
							<RefreshIcon />
						</Button>
						</Box>
					</Grid>
				</Grid>
				</Grid>

				<div hidden={!indicatorsLoading}>
					<LinearProgress variant="determinate" value={30}/>
				</div>

				<Grid container alignItems="stretch" className={classes.firstGrid}>
					<Grid item xs={12} sm={col}>
						<HasPermission menuName="Dashboard invoices" actionName="My invoices">
							<MyTasks elevation={26} square />
						</HasPermission>
					</Grid>
					<Grid container item xs={12} sm={col}>
						<HasPermission menuName="Dashboard invoices" actionName="Exported invoices">
							<Grid item xs={12}>
								<PaidAndUnpaidInvoice elevation={26} square />
							</Grid>
						</HasPermission>
						<Grid item xs={12}>
							<AddInvoice settings={settings} elevation={26} square />
						</Grid>
					</Grid>
					<Grid container item xs={12} sm={col}>
						<HasPermission menuName="Dashboard invoices" actionName="Non exported invoices">
							<Grid item xs={col === 12 ? 6 : 12}>
								<PerformanceAutomation elevation={26} square style={{ background: "#f8f9fa" }} />
							</Grid>
						</HasPermission>
						<HasPermission menuName="Dashboard invoices" actionName="Last actions">
							<Grid item xs={col === 12 ? 6 : 12}>
								<LitigeInvoicesRates elevation={26} square />
							</Grid>
						</HasPermission>
					</Grid>
				</Grid>
				<Grid container spacing={4}>
					<HasPermission menuName="Dashboard invoices" actionName="Last invoices">
						<Grid container spacing={4} item xs={12}>
							<Grid item xs={12} sm={12}>
								{isMenuAllowed(currentUserPermissions, "Invoices list") && (
									<InvoicesTable settings={settings} isDashboard />
								)}
							</Grid>
						</Grid>
					</HasPermission>
				</Grid>
			</>
		)
	);
}

export default Home;
